import representativeProductService from '../services/representativeProduct.service';

const representativeProducts = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return representativeProductService.create(model);
        },

        //READ
        get(_, params) {
            return representativeProductService.get(params.id, params.urlParameters, params.requestId);
        },
        getrepresentativeproductscodes(_,representativeid)
        {
            return representativeProductService.getrepresentativeproductscodes(representativeid);
        }, 
        getlist() {
            return representativeProductService.getlist();
        },

        //UPDATE
        update(_, model) {
            return representativeProductService.update(model);
        },

        //DELETE
        delete(_, id) {
            return representativeProductService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default representativeProducts;
